import React, { Component } from 'react';
import {Modal, Button,Tabs,Tab,ButtonToolbar,OverlayTrigger,Tooltip} from 'react-bootstrap';
import { TextField  } from '@rmwc/textfield';
import Scrollbar from 'react-scrollbars-custom';
import {connect} from 'react-redux';
import { Select } from '@rmwc/select';
import {CheckCaptureModalImage} from "../../action/extra_options/orderExtras.action.js";
import {handleSaveLatter} from "../../action/quote_order/quote.action.js";
import {handleCommonModal} from "../../action/quote_order/leadcustomer.action.js";
import * as validate from './validations';
import AnimButton from '../Button/AnimButton.js';
class ScreenCaptureConfirm extends React.Component {

render() {
   let style;

  if (window.screen.availWidth < 500) {
    style = {'padding': '40px 20px'};
  }
    
    return (
       <div>
              <Modal centered show={this.props.isShowCaptureModal} dialogClassName="alert-modal capture-modal react-modal" backdrop='static' keyboard={false} onHide={e=>this.props.CheckCaptureModalImage('close')}>            
            <button className="close" onClick={e=>this.props.CheckCaptureModalImage('close')}><span className="icon-close"></span></button>
            <Modal.Body  style={style}>
              <h5 className="modal-title mb-3">Confirm Building Photos</h5>
                {(this.props.const_var.i_g_A_y.length>0)?
                <div className="row">
                  <div className="col-12 mb-3">
                    <p>This Quote/Order has below building photos & 2D Drawing, please confirm if these are correct or recapture to avoid any confusions later on.</p>
                  </div>
                  {Object.entries(this.props.const_var.i_g_A_y).map(([key, value]) => {
                    if(value.image_name != "2D Layout" && value.image_name!="2D Layout1" && value.image_name != "ig-image"){
                return (
                  <div className="col-6">
                    <div className="modal-capture-img">
                      <img src={value.image} />
                    </div>
                  </div>

                    )
                    }
                })

                  }
                </div>
                :null    
                }
                 <div className="alert-footer "> 
                <a className="btn btn-white-shadow text-uppercase mw-100" onClick={(e) =>this.props.CheckCaptureModalImage('close','empty')}>               
              <span className="text">Recapture</span> </a>
               <a className="btn btn-secondary text-uppercase mw-100" onClick={(this.props.const_var.loginSession==false)?(e)=>this.props.handleSaveLatter('open'):(e) =>{this.props.CheckCaptureModalImage('close');this.props.handleCommonModal('lead_customer','save')}}>               
              <span className="text">Confirm & Continue</span>                 
            </a>
          </div>
          </Modal.Body>       
         
        </Modal>
        </div>
    )
  }
}

const mapStateToProps = (state) => {
 return {...state.reducer,...state.orderExtrasReducer}
}

const mapDispatchToProps = {
handleSaveLatter,
handleCommonModal,
CheckCaptureModalImage
}


export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ScreenCaptureConfirm);